import { GET_CLIENT_FILE, POST_CLIENT_FILE } from '../actionTypes'
import { ClientFile } from '../reducers/clientFile'

export const getClientFileAction = (clientFiles: ClientFile[]) => ({ type: GET_CLIENT_FILE, payload: clientFiles })
export const saveClientFileAction = (clientFiles: ClientFile[]) => ({ type: POST_CLIENT_FILE, payload: clientFiles })
